export default __webpack_public_path__ + "static/media/lotus-logo.141e2a6b.png";